export interface ISalonReviewsSummary {
  averageRating: number;
  reviewsCount: number;
  salonAverageRating?: number;
  employeesAverageRating?: number;
  treatmentsAverageRating?: number;
}
